import {
  SEARCH,
  SEARCH_FOCUS,
  SEARCH_BLUR,
  SAVE_CONSULTANT,
  UNSAVE_CONSULTANT,
  FETCH_SAVED_CONSULTANTS,
  REGISTER,
  LOG_IN,
  LOG_OUT,
  CHECK_AUTH_STATUS,
  CONTACT_CONSULTANT,
  SET_AVAILABLE,
  FETCH_USER_INFO,
  CREATE_EXPERIENCE,
  UPDATE_EXPERIENCE,
  DELETE_EXPERIENCE,
  FETCH_SUGGESTIONS,
  FETCH_CONSULTANT,
  UPDATE_CONSULTANT_INTERESTS,
  UPDATE_CONSULTANT_START_DATE,
  UPDATE_USER_INFO,
  COMPLETE_ONBOARDING,
  CUSTOMER_CONTACT,
  SEND_MESSAGE,
  SUBSCRIBE_TO_MESSAGES,
  UNSUBSCRIBE_FROM_MESSAGES,
  SUBSCRIBE_TO_USER_ROOMS,
  UNSUBSCRIBE_FROM_USER_ROOMS,
  SUBSCRIBE_TO_ROOM_METADATA,
  UNSUBSCRIBE_FROM_ROOM_METADATA,
  FETCH_SETTINGS,
  UPDATE_SETTINGS,
  VISIT,
  RESET_PASSWORD,
  FETCH_UNLISTED_CONSULTANTS,
  APPROVE_CONSULTANT,
  HIDE_CONSULTANT,
} from 'actionTypes'

export const search = ({ query, available, triggerNavigation = true }) => ({
  type: SEARCH,
  query,
  available,
  triggerNavigation,
})

export const searchFocus = () => ({
  type: SEARCH_FOCUS,
})

export const searchBlur = () => ({
  type: SEARCH_BLUR,
})

export const saveConsultant = id => ({
  type: SAVE_CONSULTANT,
  id,
})

export const unsaveConsultant = id => ({
  type: UNSAVE_CONSULTANT,
  id,
})

export const fetchSavedConsultants = () => ({
  type: FETCH_SAVED_CONSULTANTS,
})

export const register = ({ name, email, password }) => ({
  type: REGISTER,
  name,
  email,
  password,
})

export const logIn = (email, password) => ({
  type: LOG_IN,
  email,
  password,
})

export const logOut = () => ({
  type: LOG_OUT,
})

export const checkAuthStatus = () => ({
  type: CHECK_AUTH_STATUS,
})

export const resetPassword = email => ({
  type: RESET_PASSWORD,
  email,
})

export const contactConsultant = (id, message) => ({
  type: CONTACT_CONSULTANT,
  id,
  message,
})

export const setAvailable = available => ({
  type: SET_AVAILABLE,
  available,
})

export const fetchUserInfo = id => ({
  type: FETCH_USER_INFO,
  id,
})

export const createExperience = (consultantId, experience) => ({
  type: CREATE_EXPERIENCE,
  consultantId,
  experience,
})

export const updateExperience = (consultantId, experienceId, experience) => ({
  type: UPDATE_EXPERIENCE,
  consultantId,
  experienceId,
  experience,
})

export const deleteExperience = (consultantId, experienceId) => ({
  type: DELETE_EXPERIENCE,
  consultantId,
  experienceId,
})

export const fetchSuggestions = (suggestionType, value) => ({
  type: FETCH_SUGGESTIONS,
  suggestionType,
  value,
})

export const fetchConsultant = (consultantId, force = false) => ({
  type: FETCH_CONSULTANT,
  consultantId,
  force,
})

export const updateConsultantInterests = (consultantId, interests) => ({
  type: UPDATE_CONSULTANT_INTERESTS,
  consultantId,
  interests,
})

export const updateConsultantStartDate = (consultantId, startDate) => ({
  type: UPDATE_CONSULTANT_START_DATE,
  consultantId,
  startDate,
})

export const updateUserInfo = (consultantId, userInfo) => ({
  type: UPDATE_USER_INFO,
  consultantId,
  userInfo,
})

export const completeOnboarding = () => ({
  type: COMPLETE_ONBOARDING,
})

export const customerContact = data => ({
  type: CUSTOMER_CONTACT,
  data,
})

export const sendMessage = (roomId, message) => ({
  type: SEND_MESSAGE,
  roomId,
  message,
})

export const subscribeToMessages = roomId => ({
  type: SUBSCRIBE_TO_MESSAGES,
  roomId,
})

export const unsubscribeFromMessages = roomId => ({
  type: UNSUBSCRIBE_FROM_MESSAGES,
  roomId,
})

export const subscribeToRoomMetadata = roomId => ({
  type: SUBSCRIBE_TO_ROOM_METADATA,
  roomId,
})

export const unsubscribeFromRoomMetadata = roomId => ({
  type: UNSUBSCRIBE_FROM_ROOM_METADATA,
  roomId,
})

export const subscribeToUserRooms = () => ({
  type: SUBSCRIBE_TO_USER_ROOMS,
})

export const unsubscribeFromUserRooms = () => ({
  type: UNSUBSCRIBE_FROM_USER_ROOMS,
})

export const fetchSettings = () => ({
  type: FETCH_SETTINGS,
})

export const updateSettings = settings => ({
  type: UPDATE_SETTINGS,
  settings,
})

export const visit = page => ({
  type: VISIT,
  page,
})

export const fetchUnlistedConsultants = () => ({
  type: FETCH_UNLISTED_CONSULTANTS,
})

export const approveConsultant = consultantId => ({
  type: APPROVE_CONSULTANT,
  consultantId,
})

export const hideConsultant = consultantId => ({
  type: HIDE_CONSULTANT,
  consultantId,
})



// WEBPACK FOOTER //
// ./src/actions.js